/*
 * @Author: zxl
 * @Date: 2020-03-24 16:09:49
 * @FilePath: \serveradmin_frontend\src\mixins\mixins.js
 * @Description: 
 */
export const mixins = {
  data () {
    return {

      tableHeight: window.innerHeight * 0.7,
      pickerOptions: {
        disabledDate: time => time.getTime() > Date.now()
      }
    }
  },
  methods: {
    //是否为对象
    checkObj: obj => Object.prototype.toString.call(obj) === '[object Object]',
    /**
     * @description: 过滤对象的空值
     * @param {Object}obj
     * @param {Boolean}deep //是否深入过滤 0
     * @return: 处理后对象
     */
    checkTrueKeys (obj = {}, deep = false) {
      Object.keys(obj).forEach(key => {
        const item = obj[key]
        if (!item) {
          if (item !== 0) delete obj[key]
          else deep && delete obj[key]
        }
      })
      return obj
    },
    /**
     * @description: 过滤数组内对象个体空值
     * @param {Array}arr 
     * @param {Boolean}deep //是否深入过滤 0
     * @return: 处理后数组
     */
    checkArrayObjectKeys (arr = [], deep = false) {
      return arr.map(obj => this.checkTrueKeys(obj, deep))
    },
    /**
     * @description: 设置数组（字符或对象）localStorage缓存 //session也是类似
     * @param {String} keys
     * @param {Array} arr
     * @param {String} joins
     */
    setArrLocal (keys, arr = []) {
      const strs = arr.map(item => {
        if (this.checkObj(item)) return JSON.stringify(item)
        else return item
      }).join('-zxl-')
      localStorage.setItem(keys, strs)
    },
    //获取数组localStorage缓存
    getArrLocal (keys) {
      const str = localStorage.getItem(keys) || ''
      return str.split('-zxl-').map(item => {
        if (item || item === 0) {
          if (this.checkObj(item)) return JSON.parse(item)
          else return item
        }
      }).filter(item => item || item === 0)
    },
    isNumber: n => typeof n === 'number' && !isNaN(n),
    isFloat: n => ~~n !== n,
    //修复数据精度
    getFix: (n, precision) => {
      if (precision) {
        return parseInt((n * 1).toFixed(2))
      } else {
        return (n * 1).toFixed(2)
      }
    },
    handleHeaderCell ({ rowIndex, columnIndex }) {
      if (rowIndex == 0) {
        let style = { color: '#000000' }
        switch (columnIndex) {
          case 1:
            style['background-color'] = '#1f79ce'
            break;
          case 2:
            style['background-color'] = '#35af76'
            break;
          case 3:
            style['background-color'] = '#8f269c'
            break;
          case 4:
            style['background-color'] = '#FFFF00'
        }
        if (style['background-color']) return style
      }
    }
  }
}

export const constant = {
  art_type_image: [
    {
      value: 1,
      label: 'Normal'
    },
    {
      value: 2,
      label: 'Daily'
    },
    {
      value: 3,
      label: 'Theme'
    }
  ],
  show_options: [
    {
      value: 3,
      label: '下线'
    },
    {
      value: 1,
      label: '上线'
    },
    {
      value: 2,
      label: '未上线'
    }
  ],
  color_options: [
    {
      value: "normal",
      label: '单色图'
    },
    {
      value: "colored",
      label: '彩色图'
    },
    {
      value: "bm_normal",
      label: 'BMP单色图'
    },
    {
      value: "bm_color",
      label: 'BMP彩色图'
    },
    {
      value: "bm_blend",
      label: 'BMP混合'
    }
  ],
  blend_options: [
    {
      value: 0,
      label: '非Blend类型'
    },
    {
      value: 1,
      label: 'Blend类型'
    }
  ],
  allot_options: [
    {
      value: 0,
      label: '未分配'
    },
    {
      value: 1,
      label: '已分配'
    }
  ],
  status_options: [
    {
      value: 1,
      label: '待组长审核'
    },
    {
      value: 2,
      label: '待运营审核'
    },        {
      value: 3,
      label: '组长驳回'
    },        {
      value: 4,
      label: '运营驳回'
    },        {
      value: 5,
      label: '运营审核通过'
    }
  ], 
  unlock_type_options: [
    {
      value: 0,
      label: 'Free'
    },
    {
      value: 1,
      label: 'Vip'
    },
    {
      value: 2,
      label: 'Ad'
    }
  ],
  corner_marker_options: [
    {
      value: 0,
      label: 'New'
    },
            {
      value: 5,
      label: 'Hot'
    },
    {
      value: 1,
      label: 'Special'
    },
    {
      value: 2,
      label: 'Jigsaw'
    },
    {
      value: 3,
      label: 'Animation' // 万圣节专用
    },
    {
      value: 6,
      label: 'Halloween'
    },
    {
      value: 4,
      label: 'None'
    },
    {
      value: 7,
      label: 'Christmas'
    },
    {
      value: 8,
      label: 'Valentine'
    },
    {
      value: 9,
      label: 'Wallpaper'
    }
  ],
  distribute_flag_options:[
    {
      value:0,
      label: "否"
    },
    {
      value:1,
      label: "是"
    }
  ],  
}

export const page_constant = {
  size : 10,
  cur_page: 1,
  total_count: 0,
}
